import {label} from "../../service";

export const HomeSubHeader = () => {
    return <section className={"home_subheader"}>
        {label('home_page_subheader')} 🛡
    </section>
}